import * as React from "react";
import { NoSSR } from "@xingternal/crate-utils-no-ssr";
const LazyNoAccessPage = React.lazy(async () => ({
  default: (await import("@xingternal/crate-communication-error-pages")).NoAccessPage
}));
const NoAccessPage = () => /* @__PURE__ */ React.createElement(NoSSR, null, /* @__PURE__ */ React.createElement(React.Suspense, {
  fallback: /* @__PURE__ */ React.createElement(React.Fragment, null)
}, /* @__PURE__ */ React.createElement(LazyNoAccessPage, null)));
export {
  NoAccessPage
};
